import React from "react";
import { makeStyles } from "@material-ui/styles";
import { Container, List, ListItem, Typography } from "@material-ui/core";
import backgroundImage from "./challenge-background-init-flowers.svg";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    height: "100%",
    backgroundColor: "rgba(105,196,104, 1)",
    fontWeight: "bold",
    color: "rgba(38,38,101, 1)",
    backgroundImage: `url(${backgroundImage})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "cover",
    [theme.breakpoints.up("md")]: {
      backgroundColor: "rgba(105,196,104, 1)",
      backgroundImage: `url(${backgroundImage})`,
      backgroundRepeat: "no-repeat",
      backgroundPositionY: "bottom",
      backgroundSize: "100%",
    },
  },
}));

const Init = () => {
  const classes = useStyles();

  return (
    <Container className={classes.root} maxWidth={false} >
      <Typography variant="h3" color="inherit">
        Get ready
      </Typography>
    </Container>
  );
};

export default Init;
